import type { ConfigProviderProps } from 'antd/es/config-provider';

import { css } from 'config/emotionCss';

const rootStyle = css`
  &.ant-collapse .ant-collapse-item > .ant-collapse-header {
    align-items: center;

    .fb-icon--arrow-down {
      /* antd animates its own arrow over motionDurationSlow; the app has always used a shorter,
         sharper flip, and that token also drives the panel motion so it cannot be changed here. */
      transition: transform 100ms ease-in;
    }

    &[aria-expanded='true'] .fb-icon--arrow-down {
      transform: rotate(-180deg);
    }
  }
`;

const collapseConfig: ConfigProviderProps['collapse'] = {
  expandIcon: () => <i className="fb-icon--arrow-down" />,
  classNames: { root: rootStyle },
};

export default collapseConfig;
